export enum UpdateTypeEnum {
    simple = 'simple',
    advancedAuto = 'advanced_auto',
    advancedManual = 'advanced_manual',
}
